import { DateTime } from 'luxon';

export const fromISOInUTC = iso => {
  const conf = { zone: 'UTC' };
  return DateTime.fromISO(iso, conf);
};
